<script>
    import {flip} from 'svelte/animate';
    import {scale} from 'svelte/transition';
    import Grupo from "./Grupo.svelte";

    export let grupos;
</script>

<style>
    .arbolDeGrupos ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .hijos {
        margin-left: var(--padding-global);
    }
</style>

<div class="arbolDeGrupos">
    <div class="inner">
        <ul>
            {#each grupos as grupo (grupo.id)}
                <li animate:flip={{duration: 100}} transition:scale|local={{duration: 100}}>
                    <Grupo {grupo} on:eliminar-grupo />
                    {#if grupo.hijos.length}
                        <div class="hijos">
                            <svelte:self on:eliminar-grupo grupos={grupo.hijos} />
                        </div>
                    {/if}
                </li>
            {/each}
        </ul>
    </div>
</div>